import React, { useState } from 'react';
import { isHauptadmin } from '../../lib/globalData';
import { useRecordContext, useTranslate, List, Filter, Edit, Datagrid, SimpleForm, 
  TextField, ReferenceField, TextInput, EditButton } from 'react-admin';
import Move from '../../lib/Move';
import CloseToolbar from '../../lib/CloseToolbar';
import NoPagination from '../../lib/NoPagination';

const ListForm = (props) => {
  const MoveCond = (props) => {
    const record = useRecordContext();
    return record ? <Move {...props} /> :null;
  };

  const [moveStart, setMoveStart] = useState(0);
  const getMoveStart = () => {
    return moveStart;
  }
  return (
    <List {...props} title={('bw.set.roomcattext.title')}  sort={{ field: 'pos', order: 'ASC' }} 
      exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={1000} >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} >
        <MoveCond {...props} getMoveStart={getMoveStart} setMoveStart={setMoveStart} endpoint="setRoomcattext" />
        <TextField source="bezeichnung" />
        {isHauptadmin() &&
          <TextField source="id" textAlign="right" />
        }
        <EditButton label="" />
      </Datagrid>
    </List>
  )
}

const EForm = ({hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const translate = useTranslate();
  const record = useRecordContext();
  return (
    <SimpleForm toolbar={<CloseToolbar />} {...props}> 
    <span style={{ color: 'grey', fontSize:'small' }}>{translate('bw.set.roomcattext.title')}{record?.bezeichnung}:</span>
      <span style={{ width: '100%' }}>
        <span style={{ marginRight: '.1em', position: 'relative', top: '1.9em', color: 'grey' }}>2 Betten... </span>
        <TextInput source="text_de" sx={{ width: '90%' }} />
      </span>
      <span style={{ width: '100%' }}>
        <span style={{ marginRight: '.65em', position: 'relative', top: '1.9em', color: 'grey' }}>2 Beds... </span>
        <TextInput source="text_en" sx={{ width: '90%' }} />
      </span>
      <span style={{ width: '100%' }}>
        <span style={{ marginRight: '1.3em', position: 'relative', top: '1.9em', color: 'grey' }}>2 Lits... </span>
        <TextInput source="text_fr" sx={{ width: '90%' }} />
      </span>
      <span style={{ color: 'grey', fontSize:'small' }}>{translate('bw.set.roomcattext.textBWO')}:</span>
      <span style={{ marginLeft: '.5em' }}>
        <ReferenceField source="id" reference="bwhRoomcategory" link={false}>
          <TextField source="beschr_de" /><br />
          <TextField source="beschr_en" /><br />
          <TextField source="beschr_fr" />
        </ReferenceField>
      </span>
    </SimpleForm>
  )
};

const ListFilter = (props) => (
  <Filter {...props} >
    <TextInput source="bezeichnung" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />
  </Filter>
);

const Roomcattext = {
  list: (props) => (
    <ListForm {...props} filters={<ListFilter />} />
  ),
  
  edit: (props) => (
    <Edit title='bw.bwh.image.titleEdit' mutationMode="pessimistic" {...props}>
      <EForm {...props} />
    </Edit>
  )
}   
export default Roomcattext